import React, { useEffect, useRef, useState } from "react";
import "./ChatPage.css";
import CompanionLogo from "../../assets/comapionlogo.png";
import SendIcon from "../../assets/send.png";
import chatIcon from "../../assets/chaticon.png";
import StopGenerating from "../../assets/stopgeneratingicon.png";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import axios from "axios";
import MessageCard from "./Message";
import InitialMessageSection from "./InitialMessageSection";
import { Loader } from "../../utils/util";
import {
  fetchArchiveChat,
  getChatConversation,
  getcodieVersions,
  getConvo,
  updateMessageLikeStatus,
} from "../../api/Service";
import { useChatContext } from "../../../../../context";
import { Spinner } from "../../../web-workflow/common/Helper";
import MessageLoader from "./MessageLoader";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import axiosInstance from "../../../../../axiosInterceptor";
import PromptTemplate from "./PromptTemplate";

function ChatPage() {
  const messagesRef = useRef(null);
  const { common, chatAI, scroll } = useChatContext();
  const [versionID, setVersionId] = useState(6);
  const {
    conversations,
    setConversations,
    activeConversation,
    setActiveConversation,
    messages,
    setMessages,
    isFirstMesssge,
    setIsFirstMessage,
    archivedChats,
    setArchivedChats,
    isMessagesLoading,
    setIsMessagesLoading,
  } = chatAI;
  const { mode } = common;
  const {
    isConversationsLoading,
    setIsConversationsLoading,
    hasMoreConversations,
    setHasMoreConversations,
    currentPage,
    setCurrentPage,
  } = scroll;

  const [isOpen, setIsOpen] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [error, setError] = useState("");
  const [selectedModal, setSelectedModal] = useState(5);
  const [stopGenerating, setStopGenerating] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [isPrevMessagesLoading, setIsPrevMessagesLoading] = useState(false);
  const [hasPrevMessages, setHasPrevMessages] = useState(true);
  const [prevMszPageNumber, setPrevMszPageNumber] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listening, setListening] = useState(false);
  const [finalTotalText, setFinalTotalText] = useState("");
  const [selectedStateBasedOpt, setselectedStateBasedOpt] = useState("None");
  const [openParameter, setOpenParameter] = useState(false);
  const [clarificationQuestionContext, setClarificationQuestionContext] =
    useState(null);
  const [responseStatus, setResponseSatus] = useState("");
  const [codieVersionsData, setCodieVersionsData] = useState([]);
  const [initialPrompt, setInitialPrompt] = useState(null);
  const getChatParameterValues = JSON.parse(localStorage.getItem("ChatValues"));
  const [userResponseArray, setUserResponseArray] = useState([]);
  const [showLocationWarning, setShowLocationWarning] = useState(false);
  const [llmversions,setLlmVersions] = useState("")
  const [chatParameterValues, setChatParameterValues] = useState({
    temperature: getChatParameterValues?.temperature ?? 0,
    top_p: getChatParameterValues?.top_p ?? 1,
    ...(selectedModal === "VERSION_1" && {
      top_k: getChatParameterValues?.top_k ?? 250,
    }),
    max_tokens: getChatParameterValues?.max_tokens ?? 2048,
  });
  const inifinteWrapperClassName = ".chat-infinte-scroll";

  useEffect(() => {
    const matchingVersion = codieVersionsData.find(
      (eachVersion) => eachVersion.version_id === selectedModal
    );
    if (matchingVersion && matchingVersion.version_id !== versionID) {
      setVersionId(matchingVersion.version_id);
    }
  }, [selectedModal, versionID]);
  //console.log(versionID,'all version id');
  const scrollToBottomFn = (prevHeight = 0) => {
    setTimeout(() => {
      const el = document.querySelector(inifinteWrapperClassName);
      if (el) {
        const { scrollHeight } = el;
        el.scrollTop = scrollHeight - prevHeight;
      }
    }, 0);
  };

  const getConversations = async (pageNum, loadMore) => {
    try {
      setIsConversationsLoading(true);
      const messages = await getConvo(pageNum);
      if (loadMore) {
        setConversations([...conversations, ...messages]);
      } else {
        setConversations(messages);
      }
      setHasMoreConversations(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      return messages;
    } catch (err) {
      //console.log("get_convo_error:::", err.message);
      setHasMoreConversations(false);
      if (!loadMore) {
        setConversations([]);
      }
    } finally {
      setIsConversationsLoading(false);
    }
  };
  const getCodieVersionsData = async () => {
    try {
      const versionsData = await getcodieVersions();

      if (versionsData) {
        setCodieVersionsData([...versionsData]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getConversations(1);
    getCodieVersionsData();
  }, []);

  const handleMessageInputChange = (event) => {
    const newValue = event.target.value;

    if (newValue.length === 0) {
      setFinalTotalText("");
    }

    setMessageInput(newValue);
  };

  useEffect(() => {
    if (finalTotalText.length > 0) {
      setMessageInput(finalTotalText);
    }
  }, [finalTotalText]);

  const uploadConversationMessage = async (payload) => {
    const { conversation_id, newMessage } = payload;
    const endPoint =
      "https://c3vn4hengl.execute-api.ap-southeast-2.amazonaws.com/llm_post_messages_ics_v1";
    axiosInstance
      .post(endPoint, {
        conversation_id,
        message_sent: newMessage.question,
        answer_received: {
          answer: newMessage.answer.answer,
          contents_list: newMessage.answer.contents_list,
        },
      })
      .then((data) => {
        //console.log("CONVO UPLOADED SUCCES::", data, messages);
        const messageRes = data.data;
        setMessages([
          ...messages,
          { ...newMessage, message_id: messageRes.prompt_id },
        ]);
        scrollToBottomFn(0);
      })
      .catch((err) => {
        console.log("CONVO UPLOAD FAIL:::", err.message);
      });
  };

  const sendMessage = (input) => {
    const question = input ? input : messageInput;
    if (!question) return;

    setStopGenerating(true);
    const controller = new AbortController();
    setAbortController(controller);

    const accessToken = sessionStorage.getItem("useremail");
    const token = sessionStorage.getItem("accessToken");
    // const url = "https://cadnm6rzu8.execute-api.ap-southeast-2.amazonaws.com/ai_agent_hcs/";
    if (!initialPrompt) {
      setInitialPrompt(question);
    }
    const url =
      selectedModal == 6
        ? "https://mzqz8gj3fk.execute-api.ap-southeast-2.amazonaws.com/ai_agent_ics"
        : selectedModal == 5
        ? "https://b0nmk7q5w9.execute-api.ap-southeast-2.amazonaws.com/pallas-genai-v3-lambda"
        : null;
    console.log(url, "url");
    const newMessage = { question, response: null };

    setMessages([...messages, newMessage]);
    setIsMessageLoading(true);
    setMessageInput("");
    setFinalTotalText("");

    scrollToBottomFn(0);

    let payload = null;
    if (selectedModal == 5) {
      payload = {
        prompt: newMessage.question,
      };
    } else {
      let updatedUserResponses = [...userResponseArray];

      if (!initialPrompt) {
        setInitialPrompt(question);
      } else {
        updatedUserResponses.push(question);
        setUserResponseArray(updatedUserResponses);
      }

      payload = {
        question: initialPrompt || question,
        user_response:
          updatedUserResponses.length > 0
            ? updatedUserResponses.join("\n")
            : "",
      };

      console.log("Payload being sent:", payload);
    }
      axiosInstance
    .post(url, payload, {
      signal: controller.signal,
    })
    .then((response) => {
      const data = response.data;
        if (selectedModal === 5) {
          const responseBody = data;

          const message = data.message;
          newMessage.answer = {
            answer: message,
          };
          newMessage.answer.contents_list = responseBody?.contents_list
            ? responseBody.contents_list
            : responseBody.context
            ? responseBody.context.citations
            : [];
        } else {
          const responseBody = data
          console.log(responseBody,"responseBody")
          const message = responseBody.message || "";
          const clarificationQuestion = responseBody.clarification_question;
          setResponseSatus(responseBody.status);
          const clarificationNeeded =
            responseBody.status === "clarification_needed";
          const isComplete = responseBody.status === "complete";
            if (isComplete) {
             setUserResponseArray([]); 
             }
          const log = responseBody.current_state?.log || [];
          const finalCodes = responseBody.final_codes || null;
          const confidenceScore = responseBody.confidence_score || null;
          let fullMessage = message;

          if (clarificationNeeded && clarificationQuestion) {
            fullMessage += `\n\n🔎 Clarification Needed:\n${clarificationQuestion}`;
            setClarificationQuestionContext(question);
          }

          if (isComplete && responseBody.final_codes) {
            fullMessage += `\n\n🧾 Final Code Assignment:\n${responseBody.final_codes}`;
            if (responseBody.confidence_score) {
              fullMessage += `\n\nConfidence Score: ${responseBody.confidence_score}`;
            }
          }

          newMessage.answer = {
            answer: fullMessage,
            clarification_needed: clarificationNeeded,
            clarification_question: clarificationQuestion,
            log: log,
            contents_list: responseBody?.contents_list || [],
            final_codes: finalCodes,
            confidence_score: confidenceScore,
          };
        }

        if (isFirstMesssge) {
          getConversations()
            .then((data) => {
              const conv = data?.find(
                (conv) => conv.conversation === newMessage.question
              );
              if (conv?.conversation_id) {
                setActiveConversation(conv);
                uploadConversationMessage({
                  conversation_id: conv.conversation_id,
                  newMessage,
                });
              }
            })
            .catch((err) => console.log("SEND_CONV_ERR::", err.message));
        } else {
          uploadConversationMessage({
            conversation_id: activeConversation.conversation_id,
            newMessage,
          });
        }

        getConversations()
          .then((data) => {
            const conv = data.find(
              (conv) => conv.conversation === newMessage.input
            );
          })
          .catch((err) => console.log("SEND_CONV_ERR::", err.message));
      })
      .catch((error) => {
        setInitialPrompt("");
         setUserResponseArray([]);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          let errorMessage =
            error.response.status === 401
              ? "Please login again"
              : "You do not have permission to access this resource";
          window.dispatchEvent(
            new CustomEvent("tokenExpired", { detail: { errorMessage } })
          );
        }
        setMessages([...messages]);
      })
      .finally(() => {
        setIsMessageLoading(false);
        setStopGenerating(false);
      });

    if (isFirstMesssge) {
      const postpayload = {
        conversation: question,
        version_id: versionID,
      };

      const postapiEndpoint =
        "https://zyrk7br819.execute-api.ap-southeast-2.amazonaws.com/llm_post_conversation_ics_v1";
      axiosInstance
        .post(postapiEndpoint, postpayload, { signal: controller.signal })
        .then((response) => {
          const { data } = response;
          if (data.errorMessage) {
            throw new Error(data.errorMessage);
          }
        })
        .catch((error) => {
          setError(error.message);
        });

      setIsFirstMessage(false);
    }
  };

//   const sendMessage = (input) => {
//   const question = input || messageInput;
//   if (!question) return;

//   setStopGenerating(true);
//   const controller = new AbortController();
//   setAbortController(controller);

//   const token = sessionStorage.getItem("accessToken");
//   const accessToken = sessionStorage.getItem("useremail");

//   if (!initialPrompt) {
//     setInitialPrompt(question);
//   }

//   const url =
//     selectedModal === 1
//       ? "https://i8moplfb4i.execute-api.us-west-2.amazonaws.com/pallas-ai-gen-ai-lambda-func-v4/"
//       : selectedModal === 2
//       ? "https://b1hdji8l05.execute-api.us-west-2.amazonaws.com/lambdaAWSQV2"
//       : selectedModal === 5
//       ? "https://aqxmaosqw0.execute-api.ap-southeast-2.amazonaws.com/pallas-genai-v3-lambda"
//       : selectedModal === 6
//       ? "https://ffdspxt8w5.execute-api.ap-southeast-2.amazonaws.com/ai_agent_hcs"
//       : null;

//   if (!url) {
//     console.error("Invalid modal type or missing URL");
//     return;
//   }

//   const newMessage = { question, response: null };
//   setMessages([...messages, newMessage]);
//   setIsMessageLoading(true);
//   setMessageInput("");
//   setFinalTotalText("");

//   scrollToBottomFn(0);

//   // Prepare payload for each modal version
//   let payload = {};
//   if (selectedModal === 1 || selectedModal === 5) {
//     payload = { prompt: newMessage.question };
//   } else if (selectedModal === 2) {
//     payload = { prompt: newMessage.question };
//   } else if (selectedModal === 6) {
//     let updatedUserResponses = [...userResponseArray];

//     if (initialPrompt !== question) {
//       updatedUserResponses.push(question);
//       setUserResponseArray(updatedUserResponses);
//     }

//     payload = {
//       question: initialPrompt || question,
//       user_response: updatedUserResponses.join("\n"),
//     };
//   }

//   const headers = {
//     "Content-Type": "application/json",
//   };

//   if (selectedModal === 1 || selectedModal === 2) {
//     headers["authorizationToken"] = token;
//   }

//   const apiCall = selectedModal === 1 || selectedModal === 2
//     ? fetch(url, {
//         method: "POST",
//         headers,
//         body: JSON.stringify(payload),
//         signal: controller.signal,
//       }).then(res => {
//         if (!res.ok) throw new Error("Network error");
//         return res.json();
//       })
//     : axiosInstance.post(url, payload, { signal: controller.signal });

//   apiCall
//     .then((response) => {
//       const data = selectedModal === 1 || selectedModal === 2 ? JSON.parse(response.body) : response.data;

//       if (selectedModal === 2) {
//         const meesage = data.meesage;
//         let message = "";

//         if (meesage) {
//           for (const key in meesage) {
//             if (meesage[key].answer) {
//               message += meesage[key].answer + " ";
//             }
//           }
//           message = message.trim() || "No message found";
//         } else {
//           message = "No message found";
//         }

//         newMessage.answer = {
//           answer: meesage,
//         };
//       } else if (selectedModal === 1 || selectedModal === 5) {
//         const message = data.message;
//         newMessage.answer = {
//           answer: message,
//           contents_list:
//             data.contents_list ||
//             (data.context ? data.context.citations : []),
//         };
//       } else if (selectedModal === 6) {
//         const message = data.message || "";
//         const clarificationQuestion = data.clarification_question;
//         const isClarificationNeeded = data.status === "clarification_needed";
//         const isComplete = data.status === "complete";

//         if (isComplete) setUserResponseArray([]);

//         let fullMessage = message;

//         if (isClarificationNeeded && clarificationQuestion) {
//           fullMessage += `\n\n🔎 Clarification Needed:\n${clarificationQuestion}`;
//           setClarificationQuestionContext(question);
//         }

//         if (isComplete && data.final_codes) {
//           fullMessage += `\n\n🧾 Final Code Assignment:\n${data.final_codes}`;
//           if (data.confidence_score) {
//             fullMessage += `\n\nConfidence Score: ${data.confidence_score}`;
//           }
//         }

//         newMessage.answer = {
//           answer: fullMessage,
//           clarification_needed: isClarificationNeeded,
//           clarification_question: clarificationQuestion,
//           log: data.current_state?.log || [],
//           contents_list: data.contents_list || [],
//           final_codes: data.final_codes || null,
//           confidence_score: data.confidence_score || null,
//         };
//         setResponseSatus(data.status);
//       }

//       // Upload conversation
//       if (isFirstMesssge) {
//         getConversations()
//           .then((data) => {
//             const conv = data?.find((conv) => conv.conversation === question);
//             if (conv?.conversation_id) {
//               setActiveConversation(conv);
//               uploadConversationMessage({
//                 conversation_id: conv.conversation_id,
//                 newMessage,
//               });
//             }
//           })
//           .catch((err) => console.log("SEND_CONV_ERR::", err.message));
//       } else {
//         uploadConversationMessage({
//           conversation_id: activeConversation?.conversation_id,
//           newMessage,
//         });
//       }

//       getConversations().catch((err) =>
//         console.log("SEND_CONV_ERR::", err.message)
//       );
//     })
//     .catch((error) => {
//       if (
//         error.response &&
//         (error.response.status === 401 || error.response.status === 403)
//       ) {
//         const errorMessage =
//           error.response.status === 401
//             ? "Please login again"
//             : "You do not have permission to access this resource";
//         window.dispatchEvent(
//           new CustomEvent("tokenExpired", { detail: { errorMessage } })
//         );
//       }
//       setMessages([...messages]);
//     })
//     .finally(() => {
//       setIsMessageLoading(false);
//       setStopGenerating(false);
//     });

//   // Store conversation if it's first message
//   if (isFirstMesssge) {
//     const postpayload = {
//       conversation: question,
//       version_id: versionID,
//     };

//     const postapiEndpoint =
//       "https://1687vsvd7j.execute-api.ap-southeast-2.amazonaws.com/llm_post_conversation_ics_v1";

//     axiosInstance
//       .post(postapiEndpoint, postpayload, { signal: controller.signal })
//       .then((response) => {
//         const { data } = response;
//         if (data.errorMessage) {
//           throw new Error(data.errorMessage);
//         }
//       })
//       .catch((error) => {
//         setError(error.message);
//       });

//     setIsFirstMessage(false);
//   }
// };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      sendMessage();
    }
  };

  const getConversationMessages = async (
    id,
    page_number = 1,
    isUpate = false
  ) => {
    let response;
    try {
      if (isUpate) {
        setIsPrevMessagesLoading(true);
      } else {
        setIsMessagesLoading(true);
      }
      if (id) {
        response = await getChatConversation(id, page_number);
      }
      const versions = response.conversations[0].version_id
      // console.log("response::::", response.conversations[0].version_id);
      
      setLlmVersions(versions)

       if(response.conversations[0].version_id ==5){
        setShowLocationWarning(false)
      }else{
        setShowLocationWarning(true)
      }
      
      const { conversations, isVersion2, error, version } = response;
      if (error) {
        setHasPrevMessages(false);
        return;
      }
      if (versions === 5) {
        setSelectedModal(5);
        setResponseSatus("")
      }else{
        setSelectedModal(6);
      }

      if (isUpate) {
        const chats = conversations.reverse();
        setMessages([...chats, ...messages]);
        const el = document.querySelector(inifinteWrapperClassName);
        scrollToBottomFn(el.scrollHeight);
      } else {
        setMessages(conversations.reverse());
        scrollToBottomFn(0);
      }
      setHasPrevMessages(true);
      setIsFirstMessage(false);
    } catch (err) {
      setHasPrevMessages(false);
      //console.log("CONVO_MESSAGES_ERR::", err);
    } finally {
      setIsMessagesLoading(false);
      setIsPrevMessagesLoading(false);
    }
  };
  const handleConversationClick = (convo) => {
    setActiveConversation(convo);
    getConversationMessages(convo.conversation_id);
  };
  const handleNewChatBtnClick = () => {
      if (abortController) {
    abortController.abort();
  }
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setResponseSatus("");
    setInitialPrompt(null);
    setLlmVersions("")
    setStopGenerating(false);
     setUserResponseArray([]); 
    setIsMessageLoading(false); 
  
  // Reset the abort controller
     setAbortController(null);
  };

  // const handleCoderCompanionVersion3Click = (e) => {
  //   console.log(e.target.value, "versions");
  //   const version = parseInt(e.target.value)
   
  //   if (version === 5) {
  //     setSelectedModal(version);
  //     setResponseSatus("")
  //     setLlmVersions("")
  //     setInitialPrompt(null)
  //   } else if (version === 6) {
  //     setSelectedModal(version);
  //     setResponseSatus("")
  //     setLlmVersions("")
  //     setInitialPrompt(null)
  //   }
  //   setActiveConversation({});
  //   setIsFirstMessage(true);
  //   setMessages([]);
  // };

  const handleCoderCompanionVersion3Click = (e) => {
  const version = parseInt(e.target.value);
  console.log(version, "versions");

  if ([5, 6].includes(version)) {
    setSelectedModal(version);
    setResponseSatus("");
    setLlmVersions("");
    setInitialPrompt(null);
    setShowLocationWarning(version === 6);
  }

  setActiveConversation({});
  setIsFirstMessage(true);
  setMessages([]);
};

  const handleCoderCompanionGptV3Click = () => {
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setSelectedModal("VERSION_3");
  };
  const handleStopGenerating = () => {
    abortController.abort();
    const newMessages = messages.filter(
      (message) => message.question !== messageInput
    );
    setMessages(newMessages);
    setStopGenerating(false);
  };
  const handleMessageClick = (title) => {
    setMessageInput(title);
    sendMessage(title);
  };

  const fetchArchivedConversations = async () => {
    try {
      const response = await fetchArchiveChat();
      setArchivedChats(response);
    } catch (err) {
      console.log("Error in Archived request:", err.message);
    }
  };
  const updateLikeState = ({
    session_token,
    message_id,
    is_liked,
    user_comment_on_message_response,
  }) => {
    updateMessageLikeStatus({
      session_token,
      message_id,
      is_liked,
      user_comment_on_message_response,
    }).then(() => {
      const updateMessages = messages.map((message) => {
        if (message.message_id === message_id) {
          return { ...message, is_liked };
        }
        return message;
      });
      setMessages(updateMessages);
    });
  };
  const getPrevMessages = () => {
    setPrevMszPageNumber((prev) => prev + 1);
    getConversationMessages(
      activeConversation.conversation_id,
      prevMszPageNumber + 1,
      true
    );
  };
  return (
    <>
      <PromptTemplate setFinalTotalText={setFinalTotalText} />
      <div
        className={`main-page-container ${
          mode === "DARK" ? "dark-container" : " light-container"
        }`}
      >
        {mode === "DARK" && (
          <Sidebar
            conversations={conversations}
            handleClick={handleConversationClick}
            handleNewChatBtnClick={handleNewChatBtnClick}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            getConversationsFn={getConversations}
            fetchArchivedConversations={fetchArchivedConversations}
            setMessages={setMessages}
            isLoading={isConversationsLoading}
            hasMoreConversationsVal={hasMoreConversations}
            currentPageNum={currentPage}
            versionID={versionID}
            setIsFirstMessage={setIsFirstMessage}
            setActiveConversation={setActiveConversation}
            setSelectedModal={setSelectedModal}
          />
        )}
        <div className="page-wrapper">
          <div className="chat-space-wrapper">
            <div className="coder-toggle-button">
              <div className="chat-dropdown">
                <select
                  className="chat-select"
                  value={selectedModal}
                  onChange={handleCoderCompanionVersion3Click}
                >
                  {codieVersionsData
                    .filter(
                      (chatValue) =>
                        ![
                          1,2,3,4
                        ].includes(chatValue.version_id)
                    )
                    .map((chatValue) => {
                      // console.log(chatValue, "versionData");
                      return (
                        <option
                          className="chat-option"
                          value={chatValue.version_id}
                          //  value={`VERSION_${chatValue.version_id}`}
                        >
                          {chatValue.version_name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <Header
              setError={setError}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              getConservations={getConversations}
              archivedChats={archivedChats}
              fetchArchivedConversations={fetchArchivedConversations}
              setOpenParameter={setOpenParameter}
            />
          </div>
           {showLocationWarning && (
      <div className="location-warning">
        <span style={{fontWeight:"bold"}}>Notice:</span> The selected model runs via cross-region inference. Avoid sharing any sensitive data
      </div>
    )}
          <div className="intial-message-card-wrapper">
            <div
              className={`message-wrapper ${
                messages.length === 0 ? "initial-messages" : ""
              }`}
              ref={messagesRef}
            >
              {isMessagesLoading ? (
                <Spinner />
              ) : (
                <>
                  {messages.length === 0 && (
                    <InitialMessageSection
                      handleMessageClick={handleMessageClick}
                    />
                  )}
                  <InfiniteScroll
                    isTopScroll={true}
                    className="message-wrapper chat-infinte-scroll"
                    loadMore={() => getPrevMessages()}
                    hasData={hasPrevMessages}
                    isLoading={isPrevMessagesLoading}
                  >
                    {messages.map((message) => (
                      <MessageCard
                        key={message.message_id}
                        message={message}
                        sendMessage={sendMessage}
                        updateLikeState={updateLikeState}
                        responseStatus={responseStatus}
                        llmversions={llmversions}
                      />
                    ))}
                    {isMessageLoading && <MessageLoader />}
                  </InfiniteScroll>
                </>
              )}
               {llmversions !== 6 &&responseStatus !== "complete" ? (
                <div className="search-wrapper">
                  {stopGenerating && (
                    <p
                      onClick={handleStopGenerating}
                      className="stop-generating"
                    >
                      <img src={StopGenerating} alt="CompanionLogo" />{" "}
                      <span>Stop Generating</span>
                    </p>
                  )}

                  <div>
                    <input
                      className="search-input"
                      type="text"
                      placeholder="Message AI Companion"
                      value={messageInput || finalTotalText}
                      onChange={handleMessageInputChange}
                      onKeyDown={handleKeyPress}
                    />
                  </div>
                  <div className="input-button">
                    <div className="flex-icons">
                      <div onClick={() => sendMessage()}>
                        <img
                          src={SendIcon}
                          alt="sendicon"
                          style={{ height: "25px", width: "25px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p
                  style={{
                    color: "red",
                    fontSize: "16px",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  Conversation ended. Please start a new chat to continue.
                </p>
              )} 
   

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChatPage;
